import script from "./accountInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./accountInfo.vue?vue&type=script&setup=true&lang=ts"

import "./accountInfo.vue?vue&type=style&index=0&id=46a11952&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a11952"]])

export default __exports__